// extracted by mini-css-extract-plugin
export default {"root":"SiderTitle_root__UV0pU","icon":"SiderTitle_icon__H8XXq"};